export default __webpack_public_path__ + "static/media/pause_icon.3ae7af9e.svg";